export default "__VITE_ASSET__CkJDCoKc__"